import SectionHeader from "../eventsExperiences/SectionHeader";

const CAMPAIGNS = [
  { name: "Bohos Villa", meta: "with @misha_narang", instagram: "Del8qNOsW9A" },
  { name: "Khushi Housing", meta: "with @shalinibhatia18", instagram: "DXozeNJjwyK" },
  { name: "Bohos Villa", meta: "@bohosvillaa", instagram: "Da-xbOqq3OP" },
];

const InfluencerCampaigns = () => (
  <section className="ee-section ee-showcase">
    <div className="container">
      <SectionHeader
        eyebrow="Our work"
        title="Featured"
        accent="campaigns."
        intro="A few of the creator campaigns we have planned, run and reported on."
      />
      <div className="im-reels">
        {CAMPAIGNS.map(({ name, meta, instagram }) => (
          <article key={instagram}>
            <div className="im-reel">
              <iframe
                src={`https://www.instagram.com/reel/${instagram}/embed/`}
                title={`${name} reel`}
                loading="lazy"
                scrolling="no"
                allow="encrypted-media; picture-in-picture"
              />
            </div>
            <h3 className="ee-video-name">{name}</h3>
            <p className="ee-video-meta">{meta}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default InfluencerCampaigns;
